import { Container } from '@mui/material'
import { useInventory } from 'features/Inventories/queries/useInventory'
import { useInventoryReport } from 'features/Inventories/queries/useInventoryReport'
import { SCOPE_THREE_ROUTES } from 'navigation/types/scopeThreeRoutes'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'
import { Outlet, generatePath, useLocation, useMatch, useParams } from 'react-router-dom'
import { BreadcrumbNavigation, BreadcrumbShape } from '../../components/ImpactLayout'
import { logRequestError } from '../../consts/Theme'
import { downloadReportData } from '../../features/Inventories/downloadReportData'

export const InventoriesLayout = () => {
  const { t } = useTranslation('impact/InventoriesLayout')
  const { inventoryId } = useParams()
  const { data: inventory, isLoading } = useInventory(inventoryId)
  const inventoryReport = useInventoryReport(inventoryId)
  const { pathname } = useLocation()
  const { enqueueSnackbar } = useSnackbar()

  const isCreatePath = useMatch(SCOPE_THREE_ROUTES.CREATE)
  const isSetupPath = useMatch(
    generatePath(SCOPE_THREE_ROUTES.SETUP, { inventoryId: inventoryId ?? '' })
  )
  const isTargetsPath = useMatch(
    generatePath(SCOPE_THREE_ROUTES.TARGETS, { inventoryId: inventoryId ?? '' })
  )
  const isOfftakePath = useMatch(
    generatePath(SCOPE_THREE_ROUTES.OFFTAKE, { inventoryId: inventoryId ?? '' })
  )

  const paths = pathname.split('/')
  const tabValue = paths[3]

  const breadcrumbs = [
    { name: t('inventories'), to: SCOPE_THREE_ROUTES.ROOT },
    inventoryId ? { isLoading, name: inventory?.item.name, linkProps: {} } : undefined,
    isCreatePath ? { name: t('newInventory') } : undefined,
    !!inventoryId && isSetupPath ? { name: t('setup') } : undefined,
    !!inventoryId && isTargetsPath ? { name: t('setTargets') } : undefined,
    !!inventoryId && isOfftakePath ? { name: t('offtake') } : undefined,
  ].filter(Boolean) as BreadcrumbShape[]

  return (
    <>
      <Container style={{ paddingLeft: 0, paddingRight: 0 }}>
        <BreadcrumbNavigation
          breadcrumbs={breadcrumbs}
          slots={
            !!inventory?.item?.years?.length
              ? [
                  {
                    type: 'tabs',
                    tabValue,
                    defaultTabValue: 'dashboard',
                    tabs: [
                      {
                        label: t('dashboard'),
                        to: generatePath(`${SCOPE_THREE_ROUTES.DETAIL}/dashboard`, {
                          inventoryId,
                        }),
                        value: 'dashboard',
                      },
                      {
                        label: t('boundary'),
                        to: generatePath(`${SCOPE_THREE_ROUTES.DETAIL}/boundary`, {
                          inventoryId,
                        }),
                        value: 'boundary',
                      },
                    ],
                  },
                  {
                    type: 'button',
                    name: t('download'),
                    queryLoading: isLoading,
                    width: 130,
                    loading: inventoryReport.isLoading,
                    disabled: !inventoryReport.data?.reportStr,
                    onClick: () => {
                      if (!inventory) return

                      downloadReportData(inventory.item).catch(error => {
                        logRequestError(error)

                        enqueueSnackbar(t('downloadError'), {
                          variant: 'error',
                        })
                      })
                    },
                  },
                ]
              : undefined
          }
        />
      </Container>
      <Outlet />
    </>
  )
}
